import { render } from "./JumpLinkBar.vue?vue&type=template&id=1b1d3321&scoped=true"
import script from "./JumpLinkBar.vue?vue&type=script&lang=js"
export * from "./JumpLinkBar.vue?vue&type=script&lang=js"

import "./JumpLinkBar.vue?vue&type=style&index=0&id=1b1d3321&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1d3321"]])

export default __exports__